/** 同意対象区分 */
export const CATEGORY_DIVISION = {
  // お申込み・審査に関する
  APPLY: 'apply',
  // お借入れに関する
  BORROW: 'borrow',
  // ご返済に関する
  REPAY: 'repay',
  // その他の
  OTHER: 'other',
} as const;
export type CategoryDivision = (typeof CATEGORY_DIVISION)[keyof typeof CATEGORY_DIVISION];
